import { NavLink } from 'react-router';
import { Home, Swords, Map, Award, User } from 'lucide-react';

const items = [
  { to: '/home', label: 'Accueil', icon: Home },
  { to: '/pokemons', label: 'Pokémons', icon: Swords },
  { to: '/map', label: 'Carte', icon: Map },
  { to: '/achievements', label: 'Succès', icon: Award },
  { to: '/profile', label: 'Profil', icon: User },
];

interface BottomNavProps {
  className?: string;
}

export const BottomNav = ({ className = '' }: BottomNavProps) => {
  return (
    <nav
      className={`fixed right-0 bottom-0 left-0 z-50 flex h-16 items-stretch border-t border-line-soft bg-warm pb-[env(safe-area-inset-bottom)] ${className}`}
    >
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/pokemons' ? false : undefined}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center justify-center gap-0.5 text-[10px] font-semibold transition-colors ${
              isActive ? 'text-accent' : 'text-muted hover:text-soft'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon size={20} strokeWidth={isActive ? 2.5 : 1.75} />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};
